import { useEffect, useState } from 'react';
import { Box, CircularProgress, Container, Stack, Typography } from '@mui/material';
import Iconify from '../../components/iconify';

function bearerHeaders() {
  const tkn = localStorage.getItem('tkn');
  return { 'Content-Type': 'application/json', ...(tkn ? { Authorization: `Bearer ${tkn}` } : {}) };
}

// Pick-a-site card grid for pages that are inherently site-scoped (Baseline, Monitoring,
// Spatial, Calibrations). Shown when the user has selected a project but no specific site.
export default function SitePicker({ project, pageTitle, pageDescription, onPickSite }) {
  const [sites, setSites] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!project?.id) return;
    setLoading(true);
    fetch(`/v1/flux/projects/${project.id}`, { headers: bearerHeaders() })
      .then(r => r.json())
      .then(j => { if (j.ok) setSites(j.sites || []); })
      .finally(() => setLoading(false));
  }, [project?.id]);

  return (
    <Container maxWidth="lg">
      <Stack spacing={3}>
        <Box>
          <Typography variant="overline" color="text.secondary">{project?.name}</Typography>
          <Typography variant="h4">{pageTitle}</Typography>
          {pageDescription && <Typography color="text.secondary" sx={{ mt: 0.5 }}>{pageDescription}</Typography>}
        </Box>

        <Box>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
            This page is site-scoped. Pick a site to continue:
          </Typography>
          {loading
            ? <CircularProgress size={24} />
            : (
              <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: 'repeat(2, 1fr)', lg: 'repeat(3, 1fr)' }, gap: 1.5 }}>
                {sites.map(s => (
                  <Box
                    key={s.id}
                    onClick={() => onPickSite(s)}
                    sx={{
                      p: 2.5, borderRadius: 1.5, border: '1px solid', borderColor: 'divider',
                      cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                      '&:hover': { borderColor: 'primary.main', bgcolor: 'action.hover' },
                    }}
                  >
                    <Box>
                      <Typography variant="h6">{s.name}</Typography>
                      <Typography variant="caption" color="text.secondary">
                        {s.code}
                        {s.area_ha ? ` · ${s.area_ha.toFixed(1)} ha` : ''}
                      </Typography>
                    </Box>
                    <Iconify icon="eva:arrow-ios-forward-fill" sx={{ color: 'text.secondary' }} />
                  </Box>
                ))}
                {sites.length === 0 && (
                  <Typography color="text.secondary">No sites in this project yet.</Typography>
                )}
              </Box>
            )
          }
        </Box>
      </Stack>
    </Container>
  );
}
